import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addDays from 'date-fns/add_days';
import addMonths from 'date-fns/add_months';
import subMonths from 'date-fns/sub_months';
import startOfWeek from 'date-fns/start_of_week';
export default {
    namespaced: true,
    state: {
        questions_name: [],
        datachart: [],
        databarchart: {},
        datakeygroup: [],
        activeuser: [],
        happiness: [],
        feedback: [],
        weekofyear: '',
        weekprevious: '',
        weekprevious2: '',
        dateshow: '',
        questions: [
            {
                quest_id: '-Kgs61AHOnpJ3rfyQr6t',
                category_id: '-KxQjHv0aMgv6TWNWemH',
                name: 'Happiness',
                // quest_name: 'How do you feel today at the office?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'Happiness@2x',
            },
            {
                quest_id: '-Kgn7oxLPPWlbM_ZDc_h',
                category_id: '-KxRdFigA6geGzv2zJHQ',
                name: 'Personal Growth',
                // quest_name: 'How would you rate your opportunities for growth?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'Personal-Growth@2x',
            },
            {
                quest_id: '-L0J5FFsGQYVkfcGujWo',
                category_id: '-KxRwgLlN0DpB0p7al7N',
                name: 'Recognition',
                // quest_name: 'Have you gotten any recognition in the last 7 days?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'Recognition@2x',
            },
            {
                quest_id: '-Kgs549ClADmNQwoNbbG',
                category_id: '-KxRyiIXeDebHreB12mM',
                name: 'Relationship with Colleagues',
                // quest_name: 'How would you rate the level of respect colleagues give to each other in your workplace?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'relationship-with-colleagues@2x',
            },
            {
                quest_id: '-L1FmpFO-v8IZc_B5EB7',
                category_id: '-KxRzHeGK7cuwKtAKQwF',
                name: 'Satisfaction',
                // quest_name: 'Do you feel challenged at work?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'satisfaction@2x',
            },
            {
                quest_id: '-L2ycGiBDo3rDGjLNKwW',
                category_id: '-KxRzbMWTgeqpsSbCo_6',
                name: 'Ambassadorship',
                // quest_name: 'Do you see yourself working here one year from now?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'Ambassadorship@2x',
            },
            {
                quest_id: '-L1QWPtZvax_KlJgpNxF',
                category_id: '-KxS-JNn6sNeqTD0KE53',
                name: 'Feedback',
                // quest_name: 'Do you think you get enough feedback?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'Feedback@2x',
            },
            {
                quest_id: '-L1Qug-PhtzVOR2Dr5q7',
                category_id: '-KxS-e4O2--BrGiRWbEF',
                name: 'Relationship with Managers',
                // quest_name: 'In the past 7 days, have you interacted with your manager?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'relationship-with-managers@2x',
            },
            {
                quest_id: '-L36rxTgLhZTL4mq4SV1',
                category_id: '-KxS05m9KaS70Ai6ps93',
                name: 'Wellness',
                // quest_name: 'In the past 7 days, have you felt stressed or overwhelmed at work?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'wellness@2x',
            },
            {
                quest_id: '-LtOL_iR1N-ev2b_8Tmg',
                category_id: '-KxS15s4DhoKSrjs4D7k',
                name: 'Company Alignment',
                // quest_name: 'In the past 7 days, have you felt stressed or overwhelmed at work?',
                status: {
                    green: "-",
                    yellow: "-",
                    red: "-",
                },
                success: "-",
                compare: "-",
                dimpic: 'Company-Alignment@2x',
            }
        ],
        opt_month_name: [],
        global_variable: {},
        newLabels: [],
        toneAnalyse:[],
        toneLoadingStatus: false,
        databarchartLoadingStatus: false,
        datakeygroupLoadingStatus: false,
    },
    mutations: {
        setChartSuccessScore(state: any, result: any) {
            state.datachart = result
        },
        setChartJobTenure(state: any, result: any) {
            state.databarchart = result
        },
        setDataKeyGroup(state: any, result: any) {
            state.datakeygroup = result
        },
        setDimension(state: any, result: any) {
            state.dimension = result
        },
        setWeekOfYear(state: any, result: string) {
            state.weekofyear = result
        },
        setWeekPrevious(state: any, result: string) {
            state.weekprevious = result
        },
        setWeekPrevious2(state: any, result: string) {
            state.weekprevious2 = result
        },
        setActiveUser(state: any, result: any) {
            state.activeuser = result
        },
        setHappiness(state: any, result: any) {
            state.happiness = result
        },
        setFeedBack(state: any, result: any) {
            state.feedback = result
        },
        setDateShow(state: any, result: string) {
            state.dateshow = result
        },
        setQuestionsName(state: any, result: any) {
            state.questions_name[result.id] = result.value
        },
        setOptMonthName(state: any, result: any) {
            state.opt_month_name = result
        },
        setGlobalVariable(state: any, result: any) {
            state.global_variable = result
        },
        setNewLabel(state: any, result: any) {
            state.newLabels = result
        },
        setToneAnalyse(state: any, result: any) {
            state.toneAnalyse = result
        },
        setToneLoadingStatus(state: any, value: any) {
            state.toneLoadingStatus = value
        },
        setDatabarchartLoadingStatus(state: any, value: any) {
            state.databarchartLoadingStatus = value
        },
        setDatakeygroupLoadingStatus(state: any, value: any) {
            state.datakeygroupLoadingStatus = value
        },
    },
    actions: {
        resetState({ commit }: any) {
            commit('setChartSuccessScore', [])
        },
        getGlobalVariable({ commit, state }: any, global: any) {
            commit('setGlobalVariable', global)
        },
        setWeekOfYear({ commit }: any) {
            const dateNow = new Date()
            //const weekofyear = moment().tz("Asia/Bangkok").startOf('isoWeek').format('YYYY-w')
            const weekofyear = format(startOfWeek(dateNow,{weekStartsOn:1}), 'GGGG-W')
            //const weekprevious = moment().add(-7, 'days').tz("Asia/Bangkok").startOf('isoWeek').format('YYYY-w')
            const weekprevious = format(startOfWeek(addDays(dateNow, -7),{weekStartsOn:1}), 'GGGG-W')
            //const weekprevious2 = moment().add(-14, 'days').tz("Asia/Bangkok").startOf('isoWeek').format('YYYY-w')
            const weekprevious2 = format(startOfWeek(addDays(dateNow, -14),{weekStartsOn:1}), 'GGGG-W')
            
            //const today = moment().tz("Asia/Bangkok").format('d')
            const today:any = format(dateNow, 'd')
            let startdate = ''
            let enddate = ''
            if (today > 1) {
                const date = today - 1
                //startdate = moment().add(-(date * 1), 'days').tz("Asia/Bangkok").format('MMM D')
                startdate = format(addDays(dateNow, -(date*1)), 'MMM D')
            } else if (today == 0) {
                //startdate = moment().add(-6, 'days').tz("Asia/Bangkok").format('MMM D')
                startdate = format(addDays(dateNow, -6), 'MMM D')
            } else {
                //startdate = moment().tz("Asia/Bangkok").format('MMM D')
                startdate = format(dateNow, 'MMM D')
            }
            if (today == 0) {
                //enddate = moment().add(-2, 'days').tz("Asia/Bangkok").format('MMM D')
                enddate = format(addDays(dateNow, -2), 'MMM D')
            } else
                if (today < 5) {
                    const date = 5 - today
                    //enddate = moment().add(+(date * 1), 'days').tz("Asia/Bangkok").format('MMM D')
                    enddate = format(addDays(dateNow, +(date*1)), 'MMM D')
                } else if (today == 6) {
                    //enddate = moment().add(-1, 'days').tz("Asia/Bangkok").format('MMM D')
                    enddate = format(addDays(dateNow, -1), 'MMM D')
                } else {
                    //enddate = moment().tz("Asia/Bangkok").format('MMM D')
                    enddate = format(dateNow, 'MMM D')
                }
            commit('setWeekOfYear', weekofyear)
            commit('setWeekPrevious', weekprevious)
            commit('setWeekPrevious2', weekprevious2)
            commit('setDateShow', `${startdate} - ${enddate}`)
        },
        getActivityThisWeek({ commit, state }: any, user: any) {
            const activity:any = []
            firebase.firestore().collection('weeky_activate_users').doc(`${user.company}-${state.weekofyear}`).get()
                .then(function (doc) {
                    activity[state.weekofyear] = doc.data()

                    firebase.firestore().collection('weeky_activate_users').doc(`${user.company}-${state.weekprevious}`).get()
                    .then(function (doc) {
                        activity[state.weekprevious] = doc.data()
                        if (activity[state.weekprevious] && activity[state.weekofyear]) {
                            if ((activity[state.weekprevious].users * 1) > (activity[state.weekofyear].users * 1)) {
                                const value = Math.ceil((activity[state.weekofyear].users * 100) / activity[state.weekprevious].users);
                                activity[state.weekofyear].calculate = -(100 - value)
                            } else if ((activity[state.weekofyear].users * 1) > (activity[state.weekprevious].users * 1)) {
                                const value = Math.ceil((activity[state.weekprevious].users * 100) / activity[state.weekofyear].users);
                                activity[state.weekofyear].calculate = (100 - value)
                            } else {
                                activity[state.weekofyear].calculate = 0
                            }
                        } else {
                            if (activity[state.weekofyear] === undefined) {
                                activity[state.weekofyear] = {};
                            }
                            activity[state.weekofyear].calculate = 0
                        }
                        commit('setActiveUser', activity[state.weekofyear])
                    });
                });
        },
        getHappinessThisWeek({ commit, dispatch, state }: any, user: any) {
            const happy: { [key: string]: firebase.firestore.DocumentData; } = {};
            firebase.firestore().collection('weeky_insight_happiness_and_risk').where("weekofyear", "==", state.weekofyear).where("company", "==", user.company).get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        happy[state.weekofyear] = doc.data()
                    });
                    firebase.firestore().collection('weeky_insight_happiness_and_risk').where("weekofyear", "==", state.weekprevious).where("company", "==", user.company).get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            happy[state.weekprevious] = doc.data()
                        });
                        if (happy[state.weekprevious] && happy[state.weekofyear]) {
                            const cal1 = Math.ceil((happy[state.weekofyear].happy * 100) / happy[state.weekofyear].total)
                            const cal2 = Math.ceil((happy[state.weekprevious].happy * 100) / happy[state.weekprevious].total)
                            if ((cal2 * 1) > (cal1 * 1)) {
                                happy[state.weekofyear].calculatehappy = -(cal2 - cal1)
                            } else if (cal1 > cal2) {
                                const value = Math.ceil((happy[state.weekprevious].happy * 100) / happy[state.weekofyear].happy)
                                happy[state.weekofyear].calculatehappy = cal1 - cal2
                            } else {
                                happy[state.weekofyear].calculatehappy = 0
                            }
            
                            const cal11 = Math.ceil((happy[state.weekofyear].worse * 100) / happy[state.weekofyear].total)
                            const cal22 = Math.ceil((happy[state.weekprevious].worse * 100) / happy[state.weekprevious].total)
                            if ((cal22 * 1) > (cal11 * 1)) {
                                happy[state.weekofyear].calculaterisk = -(cal22 - cal11)
                            } else if ((cal11 * 1) > (cal22 * 1)) {
                                happy[state.weekofyear].calculaterisk = cal11 - cal22
                            } else {
                                happy[state.weekofyear].calculaterisk = 0
                            }
                        } else {
                            if (happy[state.weekofyear] === undefined) {
                                happy[state.weekofyear] = {};
                            }
                            happy[state.weekofyear].calculatehappy = 0
                            happy[state.weekofyear].calculaterisk = 0
                        }
                        happy[state.weekofyear].happy = Math.ceil((happy[state.weekofyear].happy * 100) / happy[state.weekofyear].total)
                        happy[state.weekofyear].worse = Math.ceil((happy[state.weekofyear].worse * 100) / happy[state.weekofyear].total)
                        commit('setHappiness', happy[state.weekofyear])
                    });
                });
        },
        getFeedbackThisWeek({ commit, dispatch, state }: any, user: any) {
            const feedback: { [key: string]: firebase.firestore.DocumentData; } = {};
            firebase.firestore().collection('weeky_insight_feedback').where("weekofyear", "==", state.weekofyear).where("company", "==", user.company).get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        feedback[state.weekofyear] = doc.data()
                    });
                    firebase.firestore().collection('weeky_insight_feedback').where("weekofyear", "==", state.weekprevious).where("company", "==", user.company).get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            feedback[state.weekprevious] = doc.data()
                        });
                        if (feedback[state.weekprevious] && feedback[state.weekofyear]) {
                            const cal1 = Math.ceil((feedback[state.weekofyear].feedback * 100) / feedback[state.weekofyear].total)
                            const cal2 = Math.ceil((feedback[state.weekprevious].feedback * 100) / feedback[state.weekprevious].total)
                            if ((cal2 * 1) > (cal1 * 1)) {
                                feedback[state.weekofyear].calculate = -(cal2 - cal1)
                            } else if ((cal1 * 1) > (cal2 * 1)) {
                                feedback[state.weekofyear].calculate = (cal1 - cal2)
                            } else {
                                feedback[state.weekofyear].calculate = 0
                            }
                        } else {
                            if (feedback[state.weekofyear] == undefined) {
                                feedback[state.weekofyear] = {}
                            }
                            feedback[state.weekofyear].calculate = 0
                        }
                        feedback[state.weekofyear].feedback = Math.ceil((feedback[state.weekofyear].feedback * 100) / feedback[state.weekofyear].total)
                        commit('setFeedBack', feedback[state.weekofyear])
                    });
                });
        },
        getQuestionsName({ state,commit }: any){
            const { questions } = state
            _.forEach(questions, async (value, index) => {
                const question = (await firebase.database().ref(`/questions/${questions[index].quest_id}`).once('value')).val();
                //questions[index].quest_name = (question_name[index]!=undefined)?question_name[index]:''
                questions[index].repeats = question.repeats
                if(question.repeats == 'weekly'){
                    questions[index].repeat_days = question.repeat_days
                    questions[index].repeat_every = question.repeat_every
                }
                commit('setQuestionsName',{id:questions[index].quest_id,value:question.question_en});
            });
        },
        getQuestionDataPrevious(){

        },
        getQuestionData({ state }: any, user: any) {
            const dateNow = new Date()
            let weekprevious = format(startOfWeek(addDays(dateNow, -7),{weekStartsOn:1}), 'GGGG-W')
            //const weekprevious2 = moment().add(-14, 'days').tz("Asia/Bangkok").startOf('isoWeek').format('YYYY-w')
            let weekprevious2 = format(startOfWeek(addDays(dateNow, -14),{weekStartsOn:1}), 'GGGG-W')
            // const check1:any[] = weekprevious.split('-')
            // if(check1[1] == '01'){
            //     weekprevious = (check1[0]*1)+1+'-01'
            // }
            // const check2:any[] = weekprevious2.split('-')
            // if(check2[1] == '01'){
            //     weekprevious2 = (check2[0]*1)+1+'-01'
            // }
            let monthofyear1: Array<any> = [];
            var promise4 = new Promise(function(resolve, reject) {
                const data4: { [key: string]: firebase.firestore.DocumentData; } = {}
                firebase.firestore().collection('insight_engagement_monthofyear').where("company", "==", user.company).where("date", ">=", format(addDays(new Date(), -60), 'YYYY-MM-DD')).where("date", "<", format(addDays(new Date(), -30), 'YYYY-MM-DD')).orderBy('date', 'desc').get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        if(monthofyear1[doc.data().quest_id] == undefined){
                            monthofyear1[doc.data().quest_id] = doc.data()
                            data4[doc.data().quest_id] = doc.data()
                        }
                        
                    });
                    resolve(data4);
                });
            });
            let monthofyear2: Array<any> = [];
            var promise3 = new Promise(function(resolve, reject) {
                const data3: { [key: string]: firebase.firestore.DocumentData; } = {}
                firebase.firestore().collection('insight_engagement_monthofyear').where("company", "==", user.company).where("date", ">=", format(addDays(new Date(), -30), 'YYYY-MM-DD')).where("date", "<", format(new Date(), 'YYYY-MM-DD')).orderBy('date', 'desc').get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        if(monthofyear2[doc.data().quest_id] == undefined){
                            monthofyear2[doc.data().quest_id] = doc.data()
                            data3[doc.data().quest_id] = doc.data()
                        }
                    });
                    resolve(data3);
                });
            });
            var promise2 = new Promise(function(resolve, reject) {
                const data2: { [key: string]: firebase.firestore.DocumentData; } = {}
                firebase.firestore().collection('insight_engagement_weekofyear').where("weekofyear", "==", weekprevious2).where("company", "==", user.company).get()
                .then(function (querySnapshot) {
                    let i = 0;
                    const _tmp: { [key: string]: number } = {}
                    _tmp['red'] = 0;
                    _tmp['yellow'] = 0;
                    _tmp['green'] = 0;
                    querySnapshot.forEach(function (doc) {
                        if (doc.data().quest_id == '-Kgs61AHOnpJ3rfyQr6t') {
                            _tmp['red'] += doc.data().red
                            _tmp['yellow'] += doc.data().yellow
                            _tmp['green'] += doc.data().green
                            i++
                        }
                        data2[doc.data().quest_id] = doc.data()
                    });
                    if (data2['-Kgs61AHOnpJ3rfyQr6t']) {
                        data2['-Kgs61AHOnpJ3rfyQr6t'].red = Math.ceil(_tmp['red'] / i)
                        data2['-Kgs61AHOnpJ3rfyQr6t'].yellow = Math.ceil(_tmp['yellow'] / i)
                        data2['-Kgs61AHOnpJ3rfyQr6t'].green = Math.ceil(_tmp['green'] / i)
                    }
                    resolve(data2);
                });
            });
            var promise1 = new Promise(function(resolve, reject) {
                const data1: { [key: string]: any; } = {}
                firebase.firestore().collection('insight_engagement_weekofyear').where("weekofyear", "==", weekprevious).where("company", "==", user.company).get()
                .then(function (querySnapshot) {
                    let i = 0;
                    const _tmp: { [key: string]: number } = {}
                    _tmp['red'] = 0;
                    _tmp['yellow'] = 0;
                    _tmp['green'] = 0;
                    querySnapshot.forEach(function (doc) {
                        if (doc.data().quest_id == '-Kgs61AHOnpJ3rfyQr6t') {
                            _tmp['red'] += doc.data().red
                            _tmp['yellow'] += doc.data().yellow
                            _tmp['green'] += doc.data().green
                            i++
                        }
                        data1[doc.data().quest_id] = doc.data()
                    });
                    if (data1['-Kgs61AHOnpJ3rfyQr6t']) {
                        data1['-Kgs61AHOnpJ3rfyQr6t'].red = Math.ceil(_tmp['red'] / i)
                        data1['-Kgs61AHOnpJ3rfyQr6t'].yellow = Math.ceil(_tmp['yellow'] / i)
                        data1['-Kgs61AHOnpJ3rfyQr6t'].green = Math.ceil(_tmp['green'] / i)
                    }
                    resolve(data1);
                });
            });
            
            Promise.all([promise1, promise2, promise3, promise4]).then((values)=> {
                const data1:any = values[0]
                const data2:any = values[1]
                const data3:any = values[2]
                const data4:any = values[3]
                const { questions } = state
                firebase.firestore().collection('insight_engagement').where("company", "==", user.company).get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            if(doc.data().quest_id !== '-Kgn7oxLPPWlbM_ZDc_h' && doc.data().quest_id !== '-Kgs549ClADmNQwoNbbG' && doc.data().quest_id !== '-L1FmpFO-v8IZc_B5EB7' && doc.data().quest_id !== '-L2ycGiBDo3rDGjLNKwW' && doc.data().quest_id !== '-LtOL_iR1N-ev2b_8Tmg'){
                                if (data1[doc.data().quest_id] != undefined) {
                                    if (doc.data().update == data1[doc.data().quest_id].update && data2[doc.data().quest_id]) {
                                        data1[doc.data().quest_id] = (data2[doc.data().quest_id]) ? data2[doc.data().quest_id] : undefined
                                    }
                                    _.forEach(questions, (value, index) => {
                                        if (value.quest_id == doc.data().quest_id) {
                                            questions[index].status.green = (doc.data().green) ? doc.data().green : 0
                                            questions[index].status.red = (doc.data().red) ? doc.data().red : 0
                                            questions[index].status.yellow = (doc.data().yellow) ? doc.data().yellow : 0
                                            questions[index].success = (isNaN(parseFloat(((((questions[index].status.green * 2) + (questions[index].status.yellow * 1)) / ((questions[index].status.green + questions[index].status.yellow + questions[index].status.red) * 2)) * 100).toFixed(1)))) ? 0 : ((((questions[index].status.green * 2) + (questions[index].status.yellow * 1)) / ((questions[index].status.green + questions[index].status.yellow + questions[index].status.red) * 2)) * 100).toFixed(1)
                                            if (data1[doc.data().quest_id]) {
                                                const cal: string = (isNaN(parseFloat(((((data1[doc.data().quest_id].green * 2) + (data1[doc.data().quest_id].yellow * 1)) / ((data1[doc.data().quest_id].green + data1[doc.data().quest_id].yellow + data1[doc.data().quest_id].red) * 2)) * 100).toFixed(1)))) ? '0' : ((((data1[doc.data().quest_id].green * 2) + (data1[doc.data().quest_id].yellow * 1)) / ((data1[doc.data().quest_id].green + data1[doc.data().quest_id].yellow + data1[doc.data().quest_id].red) * 2)) * 100).toFixed(1)
                                                const y = +cal;
                                                if (cal == questions[index].success)
                                                    questions[index].compare = 0
                                                else
                                                    questions[index].compare = Math.ceil((questions[index].success * 1) - (y * 1))
                                            }
                                        }
                                    });
                                }else{
                                    _.forEach(questions, (value, index) => {
                                        if (value.quest_id == doc.data().quest_id) {
                                            questions[index].status.green = (doc.data().green) ? doc.data().green : 0
                                            questions[index].status.red = (doc.data().red) ? doc.data().red : 0
                                            questions[index].status.yellow = (doc.data().yellow) ? doc.data().yellow : 0
                                            questions[index].success = (isNaN(parseFloat(((((questions[index].status.green * 2) + (questions[index].status.yellow * 1)) / ((questions[index].status.green + questions[index].status.yellow + questions[index].status.red) * 2)) * 100).toFixed(1)))) ? 0 : ((((questions[index].status.green * 2) + (questions[index].status.yellow * 1)) / ((questions[index].status.green + questions[index].status.yellow + questions[index].status.red) * 2)) * 100).toFixed(1)

                                            let dataQuestion =  {}
                                            firebase.firestore().collection('insight_engagement_weekofyear').where("company", "==", user.company).where("quest_id", "==", doc.data().quest_id).orderBy('weekofyear',"desc").limit(2).get()
                                            .then(function (querySnapshot) {
                                                querySnapshot.forEach(function (doc2) {
                                                    dataQuestion = doc2.data()
                                                });
                                                const cal: string = (isNaN(parseFloat(((((dataQuestion['green'] * 2) + (dataQuestion['yellow'] * 1)) / ((dataQuestion['green'] + dataQuestion['yellow'] + dataQuestion['red']) * 2)) * 100).toFixed(1)))) ? '0' : ((((dataQuestion['green'] * 2) + (dataQuestion['yellow'] * 1)) / ((dataQuestion['green'] + dataQuestion['yellow'] + dataQuestion['red']) * 2)) * 100).toFixed(1)
                                                const y = +cal;
                                                if (cal == questions[index].success)
                                                    questions[index].compare = 0
                                                else
                                                    questions[index].compare = Math.ceil((questions[index].success * 1) - (y * 1))
                                            });
                                        }
                                    });
                                }
                            }else{
                                if (data3[doc.data().quest_id] != undefined) {
                                    if (doc.data().update == data3[doc.data().quest_id].date && data4[doc.data().quest_id]) {
                                        data3[doc.data().quest_id] = (data4[doc.data().quest_id]) ? data4[doc.data().quest_id] : undefined
                                    }
                                    _.forEach(questions, (value, index) => {
                                        if (value.quest_id == doc.data().quest_id) {
                                            questions[index].status.green = (doc.data().green) ? doc.data().green : 0
                                            questions[index].status.red = (doc.data().red) ? doc.data().red : 0
                                            questions[index].status.yellow = (doc.data().yellow) ? doc.data().yellow : 0
                                            questions[index].success = (isNaN(parseFloat(((((questions[index].status.green * 2) + (questions[index].status.yellow * 1)) / ((questions[index].status.green + questions[index].status.yellow + questions[index].status.red) * 2)) * 100).toFixed(1)))) ? 0 : ((((questions[index].status.green * 2) + (questions[index].status.yellow * 1)) / ((questions[index].status.green + questions[index].status.yellow + questions[index].status.red) * 2)) * 100).toFixed(1)
                                            if (data3[doc.data().quest_id]) {
                                                const cal: string = (isNaN(parseFloat(((((data3[doc.data().quest_id].green * 2) + (data3[doc.data().quest_id].yellow * 1)) / ((data3[doc.data().quest_id].green + data3[doc.data().quest_id].yellow + data3[doc.data().quest_id].red) * 2)) * 100).toFixed(1)))) ? '0' : ((((data3[doc.data().quest_id].green * 2) + (data3[doc.data().quest_id].yellow * 1)) / ((data3[doc.data().quest_id].green + data3[doc.data().quest_id].yellow + data3[doc.data().quest_id].red) * 2)) * 100).toFixed(1)
                                                const y = +cal;
                                                if (cal == questions[index].success)
                                                    questions[index].compare = 0
                                                else
                                                    questions[index].compare = Math.ceil((questions[index].success * 1) - (y * 1))
                                            }
                                        }
                                    });
                                }else{
                                    _.forEach(questions, (value, index) => {
                                        if (value.quest_id == doc.data().quest_id) {
                                            questions[index].status.green = (doc.data().green) ? doc.data().green : 0
                                            questions[index].status.red = (doc.data().red) ? doc.data().red : 0
                                            questions[index].status.yellow = (doc.data().yellow) ? doc.data().yellow : 0
                                            questions[index].success = (isNaN(parseFloat(((((questions[index].status.green * 2) + (questions[index].status.yellow * 1)) / ((questions[index].status.green + questions[index].status.yellow + questions[index].status.red) * 2)) * 100).toFixed(1)))) ? 0 : ((((questions[index].status.green * 2) + (questions[index].status.yellow * 1)) / ((questions[index].status.green + questions[index].status.yellow + questions[index].status.red) * 2)) * 100).toFixed(1)
                                            let dataQuestion =  {}
                                            firebase.firestore().collection('insight_engagement_monthofyear').where("company", "==", user.company).where("quest_id", "==", doc.data().quest_id).orderBy('date',"desc").limit(2).get()
                                            .then(function (querySnapshot) {
                                                querySnapshot.forEach(function (doc2) {
                                                    dataQuestion = doc2.data()
                                                });
                                                const cal: string = (isNaN(parseFloat(((((dataQuestion['green'] * 2) + (dataQuestion['yellow'] * 1)) / ((dataQuestion['green'] + dataQuestion['yellow'] + dataQuestion['red']) * 2)) * 100).toFixed(1)))) ? '0' : ((((dataQuestion['green'] * 2) + (dataQuestion['yellow'] * 1)) / ((dataQuestion['green'] + dataQuestion['yellow'] + dataQuestion['red']) * 2)) * 100).toFixed(1)
                                                const y = +cal;
                                                if (cal == questions[index].success)
                                                    questions[index].compare = 0
                                                else
                                                    questions[index].compare = Math.ceil((questions[index].success * 1) - (y * 1))
                                            });
                                        }
                                    });
                                }
                            }
                            
                        });
                        ///SET DEFAULT SORT BY
                        setTimeout(() => {
                            state.questions = state.questions.sort((a, b) => { return (b.success - a.success) * -1; });
                        }, 1000);
                    });
            });
        },
        sortBy({ commit, state }: any, type: string) {
            if (type == 'lowest') {
                state.questions = state.questions.sort((a, b) => { return (b.success - a.success) * -1; });
            } else if (type == 'highest') {
                state.questions = state.questions.sort((a, b) => { return b.success - a.success; });
            }
        },
        async getDataJobTenure({ commit, state }: any, user: any) {
            commit('setDatabarchartLoadingStatus', true);
            let dataChart = {};
            firebase.firestore().collection('insight_job_tenure').where("company", "==", user.company).get()
            .then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                    const data = doc.data();
                    dataChart['labels'] = data['label']

                    // calculate from total
                    let index = 0
                    dataChart['active'] = [];
                    dataChart['people_count'] = [];
                    dataChart['happy'] = [];
                    dataChart['worse'] = [];
                    dataChart['feedback'] = [];
                    do{
                        dataChart['people_count'].push(data['active_'+index])
                        if(!data['total'][index] || data['total'][index] == 0){
                            dataChart['active'].push(0)
                        }else{
                            let cal_active = Math.ceil((data['active_'+index] * 100) / data['total'][index])
                            dataChart['active'].push((cal_active > 100) ? 100 : cal_active)
                        }

                        if(!data['happy_total_'+index] || data['happy_total_'+index] == 0){
                            dataChart['happy'].push(0)
                            dataChart['worse'].push(0)
                        }else{
                            let cal_happy = Math.ceil((data['happy_'+index] * 100) / data['happy_total_'+index])
                            let cal_worse = Math.ceil((data['worse_'+index] * 100) / data['happy_total_'+index])
                            dataChart['happy'].push((cal_happy > 100) ? 100 : cal_happy)
                            dataChart['worse'].push((cal_worse > 100) ? 100 : cal_worse)
                        }
                        
                        if(!data['feedback_total_'+index] || data['feedback_total_'+index] == 0){
                            dataChart['feedback'].push(0)
                        }else{
                            let cal_feedback = Math.ceil((data['feedback_'+index] * 100) / data['feedback_total_'+index])
                            dataChart['feedback'].push((cal_feedback > 100) ? 100 : cal_feedback)
                        }
                        index++
                    }
                    while(index < 5)
                });
                commit('setDatabarchartLoadingStatus', false);
                commit('setChartJobTenure', dataChart);
            });
            
        },
        async getDataKeyGroup({ commit, state }: any, user: any) {
            commit('setDatakeygroupLoadingStatus', true);
            const teamGroup: Array<any> = [];
            const tenureGroup: Array<any> = [];
            const keyGroupArr: Array<any> = [];
            const arrData: Array<any> = [];
            firebase.firestore().collection('insight_key_groups').where("company", "==", user.company).get()
            .then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                    const data = doc.data();
                    data.key = doc.id
                    keyGroupArr.push(data)
                });

                // Priority 1
                let HighRisk = _.filter(keyGroupArr, el => (el.categories == 'Risk') && (el.qty > 2) && (el.rate > 0.35));
                if(HighRisk.length > 0){
                    HighRisk = _.orderBy(HighRisk,['qty', 'rate'], ['desc', 'desc'])
                    HighRisk[0]['desc_text'] = 'HIGH RISK'
                    HighRisk[0]['emotion'] = 'bad'
                    arrData.push(HighRisk[0])
                }
                // Priority 2
                let LowActivity = _.filter(keyGroupArr, el => (el.categories == 'Activity') && (el.qty > 2) && (el.rate < 0.30));
                if(LowActivity.length > 0){
                    LowActivity = _.orderBy(LowActivity,['qty', 'rate'], ['desc', 'asc'])
                    LowActivity[0]['desc_text'] = 'LOW ACTIVITY'
                    LowActivity[0]['emotion'] = 'low_activity'
                    arrData.push(LowActivity[0])
                }
                // Priority 3
                let LowFeedback = _.filter(keyGroupArr, el => (el.categories == 'Feedback') && (el.qty > 2) && (el.rate < 0.20));
                if(LowFeedback.length > 0){
                    LowFeedback = _.orderBy(LowFeedback,['qty', 'rate'], ['desc', 'asc'])
                    LowFeedback[0]['desc_text'] = 'LOW FEEDBACK'
                    LowFeedback[0]['emotion'] = 'low_feedback'
                    arrData.push(LowFeedback[0])
                }
                // Priority 4
                let LowHappiness = _.filter(keyGroupArr, el => (el.categories == 'Happiness') && (el.qty > 2) && (el.rate < 0.10));
                if(LowHappiness.length > 0){
                    LowHappiness = _.orderBy(LowHappiness,['qty', 'rate'], ['desc', 'asc'])
                    LowHappiness[0]['desc_text'] = 'LOW HAPPINESS'
                    LowHappiness[0]['emotion'] = 'bad'
                    arrData.push(LowHappiness[0])
                }
                // Priority 5
                let HighActivity = _.filter(keyGroupArr, el => (el.categories == 'Activity') && (el.qty > 2) && (el.rate > 0.90));
                if(HighActivity.length > 0){
                    HighActivity = _.orderBy(HighActivity,['qty', 'rate'], ['desc', 'desc'])
                    HighActivity[0]['desc_text'] = 'HIGH ACTIVITY'
                    HighActivity[0]['emotion'] = 'good'
                    arrData.push(HighActivity[0])
                }
                // Priority 6
                let HighFeedback = _.filter(keyGroupArr, el => (el.categories == 'Feedback') && (el.qty > 2) && (el.rate > 0.80));
                if(HighFeedback.length > 0){
                    HighFeedback = _.orderBy(HighFeedback,['qty', 'rate'], ['desc', 'desc'])
                    HighFeedback[0]['desc_text'] = 'HIGH FEEDBACK'
                    HighFeedback[0]['emotion'] = 'good'
                    arrData.push(HighFeedback[0])
                }
                // Priority 7
                let HighHappiness = _.filter(keyGroupArr, el => (el.categories == 'Happiness') && (el.qty > 2) && (el.rate > 0.90));
                if(HighHappiness.length > 0){
                    HighHappiness = _.orderBy(HighHappiness,['qty', 'rate'], ['desc', 'desc'])
                    HighHappiness[0]['desc_text'] = 'HIGH HAPPINESS'
                    HighHappiness[0]['emotion'] = 'good'
                    arrData.push(HighHappiness[0])
                }
                // Priority 8
                let LowRisk = _.filter(keyGroupArr, el => (el.categories == 'Risk') && (el.qty > 2) && (el.rate == 0));
                if(LowRisk.length > 0){
                    LowRisk = _.orderBy(LowRisk,['qty'], ['desc'])
                    LowRisk[0]['desc_text'] = 'LOW RISK'
                    LowRisk[0]['emotion'] = 'good'
                    arrData.push(LowRisk[0])
                }
                commit('setDatakeygroupLoadingStatus', false);
                commit('setDataKeyGroup', arrData.slice(0, 4))
            });
        },
        getDataChart({ commit, state }: any, dataObj: any) {
            const user:any = dataObj.user;
            const quest_id = dataObj.quest_id;
            if(quest_id){
                const dateNow = new Date()
                const dateToday = format(dateNow, 'YYYY-MM-DD');
                let dataInsight: Array<any> = [];
                const response: Array<any> = [];
                const success: Array<any> = [];
                const newLabel: Array<any> = [];
                const optionsMonthName: Array<any> = [];
                const optionsMonth: Array<any> = [];
                if(quest_id != '-Kgs61AHOnpJ3rfyQr6t'){
                    for(let i = 12; i > 0; i--){
                        optionsMonthName.push(format(subMonths(dateNow,i - 1), 'MMM').toUpperCase())
                        const m = format(subMonths(dateNow,i - 1), 'YYYY-MM')
                        const daterange = {
                            month_of_year: format(subMonths(dateNow,i - 1), 'YYYY-MM'),
                        } 
                        optionsMonth.push(daterange)
                    }
                }
                if(quest_id == '-Kgs61AHOnpJ3rfyQr6t'){
                    const optionsDayName: Array<any> = [];
                    let masterDay: Array<any> = [];
                    for (let m = 31; m > 0; m--) {
                        masterDay.push(format(addDays(dateNow, -(m - 1)), 'YYYY-MM-DD'))
                        optionsDayName.push(format(addDays(dateNow, -(m - 1)), 'DD MMM'))
                    }
                    commit('setOptMonthName', optionsDayName)
                    const data1: { [key: string]: any; } = {}
                    firebase.firestore().collection('insight_engagement_day').where("company", "==", user.company).where("quest_id","==",quest_id).where("date", ">=", format(addDays(new Date(), -30), 'YYYY-MM-DD')).where("date", "<", format(new Date(), 'YYYY-MM-DD')).orderBy('date', 'asc').get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            const _data = doc.data()
                            const _tmp: { [key: string]: number } = {}
                            _tmp['red'] = (doc.data().red) ? doc.data().red : 0
                            _tmp['yellow'] = (doc.data().yellow) ? doc.data().yellow : 0
                            _tmp['green'] = (doc.data().green) ? doc.data().green : 0
                            _data.success = (isNaN(parseFloat(((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)))) ? 0 : ((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)
                            data1[doc.data().date] = _data
                        });
                        let lastexists:any = ""
                        let lastall: Array<any> = [];
                        lastall['date'] = ''
                        lastall['success'] = 0
                        // get last data
                        firebase.firestore().collection('insight_engagement_weekofyear').where("company", "==", user.company).where("quest_id","==",quest_id).where("update","<=",masterDay[0]).orderBy('update', 'desc').limit(1).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const _data = doc.data()
                                const _tmp: { [key: string]: number } = {}
                                _tmp['red'] = (doc.data().red) ? doc.data().red : 0
                                _tmp['yellow'] = (doc.data().yellow) ? doc.data().yellow : 0
                                _tmp['green'] = (doc.data().green) ? doc.data().green : 0
                                _data.success = (isNaN(parseFloat(((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)))) ? 0 : ((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)
                                lastall['success'] = _data.success
                                lastall['date'] = _data.update
                            });
                            firebase.firestore().collection('insight_engagement_weekofyear').where("company", "==", user.company).where("quest_id","==",quest_id).where("update",">=",format(addDays(new Date(), -30), 'YYYY-MM-DD')).get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const _data2 = doc.data()
                                    const _tmp: { [key: string]: number } = {}
                                    _tmp['red'] = (doc.data().red) ? doc.data().red : 0
                                    _tmp['yellow'] = (doc.data().yellow) ? doc.data().yellow : 0
                                    _tmp['green'] = (doc.data().green) ? doc.data().green : 0
                                    _data2.success = (isNaN(parseFloat(((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)))) ? 0 : ((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)
                                    data1[doc.data().update] = _data2
                                });
                                _.forEach(masterDay, (day, index) => {
                                    let txtTooltips = ""
                                    txtTooltips = optionsDayName[index]
                                    newLabel.push(txtTooltips)
                                    const _tmp: { [key: string]: number } = {}
                                    if(data1[day] && (data1[day].success || data1[day].success == '0')){
                                        _tmp['sumsuccess'] = data1[day].success
                                        lastexists = _tmp['sumsuccess']
                                    }else{
                                        if(lastexists || lastexists == '0'){
                                            _tmp['sumsuccess'] = lastexists
                                        }else if(day >= lastall['date']){
                                            _tmp['sumsuccess'] = lastall['success']
                                        }else{
                                            _tmp['sumsuccess'] = 0
                                        }
                                    }
                                    // _tmp['sumsuccess'] = (data1[day] && data1[day].success) ? data1[day].success : 0
                                    success.push(_tmp['sumsuccess'])
                                });
                                response['success'] = success
                                commit('setNewLabel',newLabel)
                                commit('setChartSuccessScore', response)
                            });
                        });
                    });
                } else if(quest_id !== '-Kgn7oxLPPWlbM_ZDc_h' && quest_id !== '-Kgs549ClADmNQwoNbbG' && quest_id !== '-L1FmpFO-v8IZc_B5EB7' && quest_id !== '-L2ycGiBDo3rDGjLNKwW' && quest_id !== '-LtOL_iR1N-ev2b_8Tmg'){
                    const { questions } = state
                    let questionsData = _.find(questions, ['quest_id', quest_id]);
                    if(questionsData && questionsData.repeat_days){
                        let arrDay = {
                            Sun: 0,
                            Mon: 1,
                            Tue: 2,
                            Wed: 3,
                            Thu: 4,
                            Fri: 5,
                            Sat: 6,
                        }
                        let dayStart:any = Object.keys(questionsData.repeat_days).filter(k=>questionsData.repeat_days[k]==="Y")
                        let masterMonth: Array<any> = [];
                        let masterMonth_fix: Array<any> = [];
                        if(dayStart && dayStart[0]){
                            for (let m = 0; m < optionsMonth.length; m++) {
                                let splitDate: Array<any> = [];
                                splitDate = optionsMonth[m]['month_of_year'].split("-")
                                let firstOfMonth = new Date(splitDate[0], splitDate[1] - 1, 1);
                                let startweekofmonth:any = format(startOfWeek(firstOfMonth,{weekStartsOn:Number(arrDay[dayStart[0]])}), 'YYYY-MM-DD')
                                if(startweekofmonth.substr(0, 7) < optionsMonth[m]['month_of_year']){
                                    startweekofmonth = format(startOfWeek(addDays(startweekofmonth, 7),{weekStartsOn:Number(arrDay[dayStart[0]])}), 'YYYY-MM-DD')
                                }
                                do{
                                    let startweekofyear = format(startOfWeek(startweekofmonth,{weekStartsOn:Number(arrDay[dayStart[0]])}), 'GGGG-W')
                                    let startweekofyear_fix = format(startOfWeek(startweekofmonth,{weekStartsOn:Number(arrDay[dayStart[0]])}), 'GGGG-WW')
                                    startweekofmonth = format(startOfWeek(addDays(startweekofmonth, 7),{weekStartsOn:Number(arrDay[dayStart[0]])}), 'YYYY-MM-DD')
                                    if(masterMonth[m] == undefined){
                                        masterMonth[m] = new Array()
                                    }
                                    masterMonth[m].push(startweekofyear)
                                    if(masterMonth_fix[m] == undefined){
                                        masterMonth_fix[m] = new Array()
                                    }
                                    masterMonth_fix[m].push(startweekofyear_fix)
                                }
                                while(startweekofmonth.substr(0, 7) == optionsMonth[m]['month_of_year'] && startweekofmonth <= dateToday)
                            }
                            
                            let lastIndex = masterMonth.length - 1
                            let start_week_of_year = masterMonth[0][0]
                            let start_week_of_year_fix = masterMonth_fix[0][0]
                            let end_week_of_year = masterMonth[lastIndex][masterMonth[lastIndex].length - 1]
                            const data1: { [key: string]: any; } = {}
                            firebase.firestore().collection('insight_engagement_weekofyear').where("company", "==", user.company).where("quest_id","==",quest_id).where('weekofyear', '>=', start_week_of_year_fix).orderBy('weekofyear', 'asc').get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const _data = doc.data()
                                    const _tmp: { [key: string]: number } = {}
                                    _tmp['red'] = (doc.data().red) ? doc.data().red : 0
                                    _tmp['yellow'] = (doc.data().yellow) ? doc.data().yellow : 0
                                    _tmp['green'] = (doc.data().green) ? doc.data().green : 0
                                    _data.success = (isNaN(parseFloat(((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)))) ? 0 : ((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)
                                    data1[doc.data().weekofyear] = _data
                                });
                                const optionsWeekOfMonthName: Array<any> = [];
                                let lastexists:any = ""
                                let lastall: Array<any> = [];
                                lastall['date'] = ''
                                lastall['success'] = 0
                                // get last data
                                firebase.firestore().collection('insight_engagement_weekofyear').where("company", "==", user.company).where("quest_id","==",quest_id).where('weekofyear', '<=', masterMonth[0][0]).orderBy('weekofyear', 'desc').limit(1).get()
                                .then(function (querySnapshot) {
                                    querySnapshot.forEach(function (doc) {
                                        const _data = doc.data()
                                        const _tmp: { [key: string]: number } = {}
                                        _tmp['red'] = (doc.data().red) ? doc.data().red : 0
                                        _tmp['yellow'] = (doc.data().yellow) ? doc.data().yellow : 0
                                        _tmp['green'] = (doc.data().green) ? doc.data().green : 0
                                        _data.success = (isNaN(parseFloat(((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)))) ? 0 : ((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)
                                        _tmp['sumsuccess'] = _data.success
                                        lastall['success'] = _tmp['sumsuccess']
                                        let splitData = _data.weekofyear.split('-')
                                        lastall['date'] = splitData[1].length == 1 ? splitData[0]+'-'+'0'+splitData[1] : splitData[0]+'-'+splitData[1]
                                    });
                                    _.forEach(masterMonth, (week, index) => {
                                        optionsWeekOfMonthName.push(optionsMonthName[index])
                                        let numweek = 1
                                        _.forEach(week, (i_weekyear, w_index) => {
                                            if(week.length !== (w_index + 1)){
                                                optionsWeekOfMonthName.push("")
                                            }
                                            let txtTooltips = ""
                                            txtTooltips = optionsMonthName[index] + " : " + "Week " + numweek
                                            newLabel.push(txtTooltips)
                                            const _tmp: { [key: string]: number } = {}
                                            if(data1[i_weekyear] && (data1[i_weekyear].success || data1[i_weekyear].success == '0')){
                                                _tmp['sumsuccess'] = data1[i_weekyear].success
                                                lastexists = _tmp['sumsuccess']
                                            }else{
                                                let splitData2 = i_weekyear
                                                let checkweek = splitData2[1].length == 1 ? splitData2[0]+'-'+'0'+splitData2[1] : splitData2[0]+'-'+splitData2[1]
                                                if(lastexists || lastexists == '0'){
                                                    _tmp['sumsuccess'] = lastexists
                                                }else if(checkweek >= lastall['date']){
                                                    _tmp['sumsuccess'] = lastall['success']
                                                }else{
                                                    _tmp['sumsuccess'] = 0
                                                }
                                            }
                                            // _tmp['sumsuccess'] = (data1[i_weekyear] && data1[i_weekyear].success) ? data1[i_weekyear].success : 0
                                            success.push(_tmp['sumsuccess'])
                                            numweek++
                                        });
                                    });
                                    response['success'] = success
                                    commit('setChartSuccessScore', response)
                                    commit('setOptMonthName', optionsWeekOfMonthName)
                                    commit('setNewLabel',newLabel)
                                });
                            });
                        }
                    }
                }else{
                    commit('setOptMonthName', optionsMonthName)
                    const startdate = format(addMonths(dateNow,-11), "YYYY-MM")+'-01'
                    const enddate = format(dateNow, "YYYY-MM")+'-31'
                    firebase.firestore().collection('insight_engagement_monthofyear').where("company", "==", user.company).where("quest_id","==",quest_id).where("date", ">=", startdate).where("date", "<", enddate).orderBy('date', 'asc').get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            const data = doc.data();
                            if(data.total && data.answer){
                                data.success = Math.ceil((data.answer / data.total) * 100)
                            }else{
                                data.success = (isNaN(parseFloat(((((data.green * 2) + (data.yellow * 1)) / ((data.green + data.yellow + data.red) * 2)) * 100).toFixed(1)))) ? 0 : ((((data.green * 2) + (data.yellow * 1)) / ((data.green + data.yellow + data.red) * 2)) * 100).toFixed(1)
                            }
                            dataInsight.push(data);
                        });
                        let lastexists:any = ""
                        let lastall: Array<any> = [];
                        lastall['date'] = ''
                        lastall['success'] = 0
                        // get last data
                        firebase.firestore().collection('insight_engagement_monthofyear').where("company", "==", user.company).where("quest_id","==",quest_id).where('date','<=',optionsMonth[0]['month_of_year']+"-01").orderBy('date', 'desc').limit(1).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.total && data.answer){
                                    data.success = Math.ceil((data.answer / data.total) * 100)
                                }else{
                                    data.success = (isNaN(parseFloat(((((data.green * 2) + (data.yellow * 1)) / ((data.green + data.yellow + data.red) * 2)) * 100).toFixed(1)))) ? 0 : ((((data.green * 2) + (data.yellow * 1)) / ((data.green + data.yellow + data.red) * 2)) * 100).toFixed(1)
                                }
                                lastall['success'] = data.success
                                lastall['date'] = data.date
                            });
                            for (let m = 0; m < optionsMonth.length; m++) {
                                let txtTooltips = ""
                                txtTooltips = optionsMonthName[m]
                                newLabel.push(txtTooltips)
                                const _tmp: { [key: string]: number } = {}
                                _tmp['sumsuccess'] = 0
                                _tmp['rows'] = 0
                                for (let index = 0; index < dataInsight.length; index++) {
                                    const element = dataInsight[index];
                                    if (element.date.substr(0, 7) == optionsMonth[m]['month_of_year']) {
                                        _tmp['sumsuccess'] = element.success
                                        lastexists = _tmp['sumsuccess']
                                    }else{
                                        if(lastexists || lastexists == '0'){
                                            _tmp['sumsuccess'] = lastexists
                                        }else if(optionsMonth[m]['month_of_year'] >= lastall['date'].substr(0, 7)){
                                            _tmp['sumsuccess'] = lastall['success']
                                        }else{
                                            _tmp['sumsuccess'] = 0
                                        }
                                    }
                                }
                                success.push(_tmp['sumsuccess'])
                                response['success'] = success
                            }
                            commit('setNewLabel',newLabel)
                            commit('setChartSuccessScore', response)
                        });
                    });
                }
            }
        },
        async getDataToneAnalyze({commit,state}:any,user:any){
            commit('setToneLoadingStatus', true);
            const dateNow = new Date();
            const _dateNow=format(new Date(dateNow), 'YYYY-MM-DD')
            const sevenago=format( dateNow.setDate(dateNow.getDate() - 7),"YYYY-MM-DD");
            const fourteenago=format( new Date().setDate(new Date().getDate() - 14),"YYYY-MM-DD");
            const sumTone={
                sum:0,
                anger:0,
                fear:0,
                joy :0,
                sadness:0,
                analytical:0,
                confident:0,
                tentative :0,
                frustrated :0,
                satisfied:0,
                excited:0,
                polite:0,
                impolite:0,
                sympathetic:0,}
            const sumToneAgo={
                    sum:0,
                    anger:0,
                    fear:0,
                    joy :0,
                    sadness:0,
                    analytical:0,
                    confident:0,
                    tentative :0,
                    frustrated :0,
                    satisfied:0,
                    excited:0,
                    polite:0,
                    impolite:0,
                    sympathetic:0,}
            const _emoji=[
                {
                    toneId: 'anger',
                    emoji: '😡',
                    emojiText: 'Anger',
                    details: 'Anger is evoked due to injustice, conflict, humiliation, negligence, or betrayal. If anger is active, the individual attacks the target, verbally or physically. If anger is passive, the person silently sulks and feels tension and hostility.'
                },
                {
                    toneId: 'fear',
                    emoji: '😨',
                    emojiText: 'Fear',
                    details: 'Fear is a response to impending danger. It is a survival mechanism that is triggered as a reaction to some negative stimulus. Fear can be a mild caution or an extreme phobia.'
                },
                {
                    toneId: 'joy',
                    emoji: '🥳',
                    emojiText: 'Joy',
                    details: 'Joy (or happiness) has shades of enjoyment, satisfaction, and pleasure. Joy brings a sense of well-being, inner peace, love, safety, and contentment.'
                },
                {
                    toneId: 'sadness',
                    emoji: '😥',
                    emojiText: 'Sadness',
                    details: 'Sadness indicates a feeling of loss and disadvantage. When a person is quiet, less energetic, and withdrawn, it can be inferred that they feel sadness.'
                },
                {
                    toneId: 'analytical',
                    emoji: '🤔',
                    emojiText: 'Analytical',
                    details: "An analytical tone indicates a person's reasoning and analytical attitude about things. An analytical person might be perceived as intellectual, rational, systematic, emotionless, or impersonal."
                },
                {
                    toneId: 'confident',
                    emoji: '🤝',
                    emojiText: 'Confident',
                    details: "A confident tone indicates a person's degree of certainty. A confident person might be perceived as assured, collected, hopeful, or egotistical."
                },
                {
                    toneId: 'tentative',
                    emoji: '😅',
                    emojiText: 'Tentative',
                    details: "A tentative tone indicates a person's degree of inhibition. A tentative person might be perceived as questionable, doubtful, or debatable."
                },
                {
                    toneId: 'frustrated',
                    emoji: '😤',
                    emojiText: 'Frustrated',
                    details: 'A frustrated tone is defined as feeling annoyed and irritable'
                },
                {
                    toneId: 'satisfied',
                    emoji: '😆',
                    emojiText: 'Satisfied',
                    details: 'A satisfied tone is an affective response to perceived service quality'
                },
                {
                    toneId: 'excited',
                    emoji: '🤩',
                    emojiText: 'Excited',
                    details: 'An excited tone indicates a person showing personal enthusiasm and interest'
                },
                {
                    toneId: 'polite',
                    emoji: '😇',
                    emojiText: 'Polite',
                    details: 'A polite tone is defined as rational, goal-oriented behavior'
                },
                {
                    toneId: 'impolite',
                    emoji: '👿',
                    emojiText: 'Impolite',
                    details: 'An impolite tone indicates a person being disrespectful and rude'
                },
                {
                    toneId: 'sympathetic',
                    emoji:'❤️',
                    emojiText: 'Sympathetic',
                    details: 'A sympathetic tone is an affective mode of understanding that involves emotional resonance'
                },
            ]
            let count_value=0
            const arr=new Array()
            const arrAgo=new Array()

            await firebase.firestore().collection('toneanalyze').where('company', '==', user.company).where('date', '>', sevenago).where('date','<=',_dateNow).get()
            .then((querySnapshot) =>  {
                querySnapshot.forEach(function (doc) {
                    const data = doc.data();
                        data.toneAnalyse.map(value=>{
                            switch(value.tone_id) {
                                case 'anger': sumTone.anger=Math.round((sumTone.anger + value.score) * 1e12) / 1e12
                                break;
                                case 'fear': sumTone.fear=Math.round((sumTone.fear + value.score) * 1e12) / 1e12
                                break;
                                case 'joy': sumTone.joy=Math.round((sumTone.joy + value.score) * 1e12) / 1e12
                                break;
                                case 'sadness': sumTone.sadness=Math.round((sumTone.sadness + value.score) * 1e12) / 1e12
                                break;
                                case 'analytical': sumTone.analytical=Math.round((sumTone.analytical + value.score) * 1e12) / 1e12
                                break;
                                case 'confident': sumTone.confident=Math.round((sumTone.confident + value.score) * 1e12) / 1e12
                                break;
                                case 'tentative': sumTone.tentative=Math.round((sumTone.tentative + value.score) * 1e12) / 1e12
                                break;
                                case 'frustrated': sumTone.frustrated=Math.round((sumTone.frustrated + value.score) * 1e12) / 1e12
                                break;
                                case 'satisfied': sumTone.satisfied=Math.round(( sumTone.satisfied + value.score) * 1e12) / 1e12
                                break;
                                case 'excited': sumTone.excited=Math.round((sumTone.excited + value.score) * 1e12) / 1e12
                                break;
                                case 'polite': sumTone.polite=Math.round((sumTone.polite + value.score) * 1e12) / 1e12
                                break;
                                case 'impolite': sumTone.impolite=Math.round((sumTone.impolite + value.score) * 1e12) / 1e12
                                break;
                                case 'sympathetic':sumTone.sympathetic=Math.round((sumTone.sympathetic + value.score) * 1e12) / 1e12
                                break;
                              
                            }
                            sumTone.sum=Math.round((sumTone.sum + value.score) * 1e12) / 1e12
                            })
                })
            })

            await firebase.firestore().collection('toneanalyze').where('company', '==', user.company).where('date', '>', fourteenago).where('date','<=',sevenago).get()
            .then((querySnapshot) =>  {
                querySnapshot.forEach(function (doc) {
                    const data = doc.data();
                    data.toneAnalyse.map(value=>{
                        switch (value.tone_id) {
                            case 'anger': sumToneAgo.anger = Math.round((sumToneAgo.anger + value.score) * 1e12) / 1e12
                                break;
                            case 'fear': sumToneAgo.fear = Math.round((sumToneAgo.fear + value.score) * 1e12) / 1e12
                                break;
                            case 'joy': sumToneAgo.joy = Math.round((sumToneAgo.joy + value.score) * 1e12) / 1e12
                                break;
                            case 'sadness': sumToneAgo.sadness = Math.round((sumToneAgo.sadness + value.score) * 1e12) / 1e12
                                break;
                            case 'analytical': sumToneAgo.analytical = Math.round((sumToneAgo.analytical + value.score) * 1e12) / 1e12
                                break;
                            case 'confident': sumToneAgo.confident = Math.round((sumToneAgo.confident + value.score) * 1e12) / 1e12
                                break;
                            case 'tentative': sumToneAgo.tentative = Math.round((sumToneAgo.tentative + value.score) * 1e12) / 1e12
                                break;
                            case 'frustrated': sumToneAgo.frustrated = Math.round((sumToneAgo.frustrated + value.score) * 1e12) / 1e12
                                break;
                            case 'satisfied': sumToneAgo.satisfied = Math.round((sumToneAgo.satisfied + value.score) * 1e12) / 1e12
                                break;
                            case 'excited': sumToneAgo.excited = Math.round((sumToneAgo.excited + value.score) * 1e12) / 1e12
                                break;
                            case 'polite': sumToneAgo.polite = Math.round((sumToneAgo.polite + value.score) * 1e12) / 1e12
                                break;
                            case 'impolite': sumToneAgo.impolite = Math.round((sumToneAgo.impolite + value.score) * 1e12) / 1e12
                                break;
                            case 'sympathetic': sumToneAgo.sympathetic = Math.round((sumToneAgo.sympathetic + value.score) * 1e12) / 1e12
                                break;
                        }
                        sumToneAgo.sum = Math.round((sumToneAgo.sum + value.score) * 1e12) / 1e12
                    })
                })
            })
            for (const [key, value] of Object.entries(sumTone)) {
                const percent = Math.round((((value / sumTone.sum) * 100) * 1e12) / 1e12).toFixed(0)
                arr.push({ percentage: value === 0 ? 0 : Number(percent), toneId: key })
            }
            for (const [key, value] of Object.entries(sumToneAgo)) {
                const percent = Math.round((((value / sumToneAgo.sum) * 100) * 1e12) / 1e12).toFixed(0)
                arrAgo.push({ percentageAgo: value === 0 ? 0 : Number(percent), toneId: key })
            }

            const tone = _.orderBy(arr, 'percentage', 'desc')
            const _tone = tone.map((value, i) => {
                return { ...value, rankingNow: i }
            })

            const toneAgo = _.orderBy(arrAgo, 'percentageAgo', 'desc')
            const _toneAgo = toneAgo.map((value, i) => { return { ...value, rankYesterdayDay: value.percentageAgo == 0 ? 0 : i } })

            var merge_tone = _.map(_tone, function (item) {
                return _.merge(item, _.find(_toneAgo, { 'toneId': item.toneId }));
            });
           
            const data_tone = merge_tone.map((value) => {
                if (value.percentage !== 0) {
                    count_value++
                }
                return { ...value, percentageChange: value.percentage - value.percentageAgo }
            })
            
            var toneAnalyse = _.map(data_tone, function (item) {
                return _.merge(item, _.find(_emoji, { 'toneId': item.toneId }));
            });
            commit('setToneLoadingStatus', false);
            commit('setToneAnalyse', toneAnalyse.slice(1, count_value <= 5 ? count_value : 6))
  
        }
    },
    getters: {
        activeuser: (state: any) => {
            return state.activeuser
        },
        dimension: (state: any) => {
            return state.dimension
        },
        happiness: (state: any) => {
            return state.happiness
        },
        feedback: (state: any) => {
            return state.feedback
        },
        dateshow: (state: any) => {
            return state.dateshow
        },
        questions: (state: any) => {
            return state.questions
        },
        questions_name: (state: any) => {
            return state.questions_name
        },
        datachart: (state: any) => {
            return state.datachart
        },
        databarchart: (state: any) => {
            return state.databarchart
        },
        datakeygroup: (state: any) => {
            return state.datakeygroup
        },
        opt_month_name: (state: any) => {
            return state.opt_month_name
        },
        newLabels: (state: any) => {
            return state.newLabels
        },
        toneAnalyse:(state: any) => {
            return state.toneAnalyse
        },
        toneloadingStatus:(state: any) => {
            return state.toneLoadingStatus
        },
        datachartloadingStatus:(state: any) => {
            return state.databarchartLoadingStatus
        },
        datakeygrouploadingStatus:(state: any) => {
            return state.datakeygroupLoadingStatus
        },
    }
}